import type { ToolContent } from "./tool-content";
import { getPtBrToolBySlug } from "./pt-br-tools-catalog";

interface PtBrSeoOverride {
  h1Title: string;
  seoTitle: string;
  seoDescription: string;
  intro: string;
  faq?: { q: string; a: string }[];
}

const PT_BR_SEO_DATA: Record<string, PtBrSeoOverride> = {
  "sorteador-de-nomes-online": {
    h1Title: "Sorteador de Nomes Online Grátis e Rápido",
    seoTitle: "Sorteador de Nomes Online Grátis | Picamini.online",
    seoDescription: "Sorteie nomes aleatórios online de forma rápida, justa e 100% gratuita. Ideal para professores, sorteios do Instagram e dinâmicas de grupo.",
    intro: "Realize sorteios de nomes de forma transparente e divertida. Cole sua lista de participantes, clique para sortear e veja a animação com o vencedor ao vivo.",
    faq: [
      {
        q: "Como funciona o sorteador de nomes online?",
        a: "Basta colar ou digitar a lista de nomes no campo indicado e clicar no botão de sortear. Nosso algoritmo escolhe um nome de forma 100% aleatória e imparcial."
      },
      {
        q: "Posso sortear mais de um vencedor por vez?",
        a: "Sim! Você pode habilitar a opção de remover o nome sorteado para realizar múltiplos sorteios em sequência sem repetições."
      }
    ]
  },
  "sorteador-de-alunos": {
    h1Title: "Sorteador de Alunos para Sala de Aula",
    seoTitle: "Sorteador de Alunos para Sala de Aula | Picamini.online",
    seoDescription: "Sorteie alunos para responder perguntas, apresentar trabalhos ou liderar tarefas de forma imparcial na sala de aula.",
    intro: "Facilite a participação dos alunos nas aulas presenciais ou virtuais com um sorteador interativo projetável que garante chances iguais para todos.",
  },
  "roleta-da-sorte-online": {
    h1Title: "Roleta da Sorte Online — Girar Roleta Personalizada",
    seoTitle: "Roleta da Sorte Online — Girar Roleta Grátis | Picamini.online",
    seoDescription: "Gire a roleta da sorte online grátis. Crie sua própria roleta personalizada com nomes, números, opções ou perguntas em segundos.",
    intro: "Gire a roleta interativa colorida e resolva escolhas, sorteios ou brincadeiras com animação realista e efeitos sonoros empolgantes.",
  },
  "roleta-de-nomes": {
    h1Title: "Roleta de Nomes Online para Sorteios",
    seoTitle: "Roleta de Nomes Online — Girar Roleta de Nomes | Picamini.online",
    seoDescription: "Roleta de nomes grátis para sorteio de alunos, brindes e prendas. Adicione seus nomes e gire a roleta ao vivo.",
    intro: "Coloque os nomes dos participantes na roleta e gire para escolher um vencedor de maneira visual, emocionante e imparcial.",
  },
  "roleta-sim-ou-nao": {
    h1Title: "Roleta Sim ou Não — Decisão 50/50 Instantânea",
    seoTitle: "Roleta Sim ou Não Online | Picamini.online",
    seoDescription: "Em dúvida? Gire a roleta Sim ou Não online e tome decisões rápidas em 50/50 em apenas um clique.",
    intro: "Resolva pequenas indecisões do dia a dia com a roleta interativa Sim ou Não. Simples, divertida e direta ao ponto.",
  },
  "roleta-de-premios": {
    h1Title: "Roleta de Prêmios e Brindes para Sorteios",
    seoTitle: "Roleta de Prêmios Online Grátis | Picamini.online",
    seoDescription: "Gire a roleta de prêmios para distribuir mimos, recompensas de alunos e brindes em eventos ou Lives.",
    intro: "Crie uma roleta premiada com valores, mimos ou desafios e transforme a entrega de prêmios em um momento divertido.",
  },
  "roleta-de-numeros": {
    h1Title: "Roleta de Números Aleatórios",
    seoTitle: "Roleta de Números Aleatórios Online | Picamini.online",
    seoDescription: "Sorteie números de 1 a 100 ou defina seu próprio intervalo numérico na roleta online.",
    intro: "Sorteie números na roleta giratória animada para rifas, brincadeiras e atividades matemáticas.",
  },
  "roleta-o-que-comer": {
    h1Title: "Roleta O Que Comer Hoje? — Escolha de Refeições",
    seoTitle: "Roleta O Que Comer Hoje Online | Picamini.online",
    seoDescription: "Não sabe o que comer no almoço ou janta? Gire a roleta de comida e descubra sua refeição de hoje!",
    intro: "Elimine o impasse do almoço ou jantar girando a roleta com opções como pizza, hambúrguer, comida japonesa, marmita e salada.",
  },
  "gerador-de-equipes": {
    h1Title: "Gerador de Equipes e Times Aleatórios",
    seoTitle: "Gerador de Equipes e Times Aleatórios | Picamini.online",
    seoDescription: "Divida listas de pessoas em times e equipes equilibrados para esportes, gincanas e trabalhos em grupo.",
    intro: "Divida turmas e grupos de amigos em equipes equilibradas em um clique sem favoritismos.",
  },
  "gerador-de-grupos-aleatorios": {
    h1Title: "Gerador de Grupos Aleatórios Online",
    seoTitle: "Gerador de Grupos Aleatórios Online | Picamini.online",
    seoDescription: "Crie grupos de trabalho aleatórios por tamanho de grupo ou número total de equipes de forma justa.",
    intro: "Organize alunos e participantes em grupos de estudo ou trabalho escolar de maneira rápida e automática.",
  },
  "gerador-de-duplas": {
    h1Title: "Gerador de Duplas e Pares Aleatórios",
    seoTitle: "Gerador de Duplas Aleatórias Online | Picamini.online",
    seoDescription: "Crie duplas aleatórias instantaneamente para trabalhos de sala de aula e jogos em dupla.",
    intro: "Gere duplas neutras e sem panelinhas para exercícios escolares e dinâmicas interativas.",
  },
  "gerador-de-numeros-aleatorios": {
    h1Title: "Gerador de Números Aleatórios",
    seoTitle: "Gerador de Números Aleatórios Online | Picamini.online",
    seoDescription: "Sorteie números em qualquer intervalo definido com opção de impedir repetições.",
    intro: "Sorteador de números flexível e rápido para rifas, jogos, amostragem estatística e pesquisas.",
  },
  "dado-virtual-online": {
    h1Title: "Dado Virtual Online — Jogar Dados na Tela",
    seoTitle: "Dado Virtual Online Grátis | Picamini.online",
    seoDescription: "Jogue dados virtuais D6, D20, D10 e D4 online com rolagem em 3D animada para jogos de tabuleiro e RPG.",
    intro: "Esqueceu os dados do jogo de tabuleiro? Jogue dados virtuais animados direto na tela do celular ou computador.",
  },
  "cara-ou-coroa-online": {
    h1Title: "Cara ou Coroa Online — Girar Moeda Virtual",
    seoTitle: "Cara ou Coroa Online Grátis | Picamini.online",
    seoDescription: "Jogue a moeda cara ou coroa online com animação em 3D realista para resolver disputas em 1 segundo.",
    intro: "Decida quem começa o jogo ou tira a sorte no cara ou coroa com lançamento de moeda totalmente aleatório.",
  },
  "cronometro-para-sala-de-aula": {
    h1Title: "Cronômetro e Temporizador para Sala de Aula",
    seoTitle: "Cronômetro para Sala de Aula Online | Picamini.online",
    seoDescription: "Temporizador de contagem regressiva em tela cheia com alarmes sonoros para gerenciar o tempo das aulas.",
    intro: "Controle o tempo de exames, trabalhos em grupo e pausas ativas com um cronômetro visual legível para toda a turma.",
  },
  "placar-digital-para-sala-de-aula": {
    h1Title: "Placar Digital Interativo para Sala de Aula",
    seoTitle: "Placar Digital para Sala de Aula | Picamini.online",
    seoDescription: "Placar de pontos para equipes, gincanas escolares e jogos educativos na tela do projetor.",
    intro: "Controle a pontuação de times e grupos em tempo real durante jogos e gincanas pedagógicas.",
  },
  "gerador-de-mimica-e-imagem": {
    h1Title: "Gerador de Mímica e Imagem (Jogo da Mímica)",
    seoTitle: "Gerador de Mímica Online Grátis | Picamini.online",
    seoDescription: "Ideias de palavras para jogo da mímica: filmes, animais, ações e profissões para brincar em grupo.",
    intro: "Divirta-se em família ou na sala de aula com um gerador automático de palavras para mímica e encenações.",
  }
};

export function getPtBrToolContent(slug: string, fallbackName: string): ToolContent {
  const tool = getPtBrToolBySlug(slug);
  const ptBrSlug = tool ? tool.slug : slug;
  const enSlug = tool ? tool.enSlug : slug;

  const override = PT_BR_SEO_DATA[ptBrSlug] || PT_BR_SEO_DATA[enSlug] || {};
  const name = fallbackName;

  return {
    seoTitle: override.seoTitle || `${name} Online Grátis | Picamini.online`,
    seoDescription: override.seoDescription || `Ferramenta de ${name.toLowerCase()} grátis online. Sorteios e escolhas rápidas de forma 100% imparcial e fácil.`,
    h1Title: override.h1Title || `${name} Online Grátis — Rápido e Fácil`,
    intro: override.intro || `Utilize a ferramenta ${name.toLowerCase()} de maneira simples, imparcial e sem precisar instalar nenhum aplicativo.`,
    whatIs: [
      `A ferramenta ${name} faz parte da suíte interativa do Picamini.online, desenvolvida para ajudar professores, estudantes, organizadores de eventos e criadores de conteúdo nas suas decisões diárias.`,
      `Sem necessidade de cadastro ou pagamento, nossa plataforma executa os sorteios de forma transparente e animada direto no seu navegador.`,
      `Funciona perfeitamente em celulares, tablets, notebooks e projetores de sala de aula.`
    ],
    howTo: [
      "Insira ou cole a sua lista de itens, nomes ou valores no campo principal.",
      "Ajuste as configurações desejadas (como permitir repetições ou efeitos sonoros).",
      "Clique no botão principal de ação para executar a escolha aleatória.",
      "Confira o resultado destacado na tela e compartilhe ou sorteie novamente."
    ],
    features: [
      "100% Gratuito e sem necessidade de cadastro",
      "Design responsivo otimizado para celulares, computadores e projetores",
      "Resultados instantâneos com animações envolventes",
      "Privacidade total: Seus dados não ficam armazenados em nossos servidores",
      "Ferramenta leve e de carregamento ultrarrápido"
    ],
    benefits: [
      "Garantia de imparcialidade e transparência em sorteios",
      "Economia de tempo no planejamento de aulas e dinâmicas",
      "Aumento do engajamento de alunos e participantes"
    ],
    proTips: [
      "Projete a tela no Datashow para criar clima de expectativa com os alunos durante as atividades escolares.",
      "Copie e salve sua lista de nomes favorita nos blocos de notas do seu dispositivo para usar sempre que precisar."
    ],
    faq: override.faq || [
      {
        q: `O ${name} é realmente gratuito?`,
        a: "Sim! Todas as ferramentas do Picamini.online são 100% gratuitas e abertas, sem cobranças escondidas nem limite de uso."
      },
      {
        q: "Preciso criar uma conta para usar a ferramenta?",
        a: "Não. Você pode acessar e utilizar qualquer sorteador ou roleta imediatamente sem precisar fazer login ou informar dados pessoais."
      }
    ]
  };
}
